import React, { Dispatch, SetStateAction } from "react";
import { TextField, Grid, } from "@mui/material";
import BoxKit from "@/shared/components/kit/box";
import UploadDocuments from "@/shared/components/common/uploadDocuments";

interface SecondRadioProps{
  setJob: any;
  job: any;
  setUploadImageJob: Dispatch<SetStateAction<any>>;
}
/**
 * SecondRadio
 *
 * کامپوننتی برای وارد کردن اطلاعات شغلی کاربران بخش خصوصی.
 * شامل فیلدهای زیر:
 * - نام شرکت
 * - سمت شغلی
 * - کد پستی شرکت
 * - شناسه ملی شرکت
 * - آدرس محل کار
 * همچنین امکان بارگذاری تصویر فیش حقوقی فراهم شده است.
 *
 * @param {Object} props
 * @param {any} props.job وضعیت فعلی اطلاعات شغلی
 * @param {Function} props.setJob تابع برای بروزرسانی اطلاعات شغلی
 * @param {Dispatch<SetStateAction<any>>} props.setUploadImageJob تابع برای بروزرسانی تصویر فیش حقوقی
 *
 * @component
 * @returns JSX.Element
 */

export default function SecondRadio({setJob,job,setUploadImageJob,}: SecondRadioProps) {

  const handleChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
      setJob((prev: any) => ({
        ...prev,
        [field]: e.target.value,
      }));
    };
    
  return (
    <BoxKit sx={{padding: 4,borderRadius: 2,width: "100%",margin: "auto",color: "white",}}>
      <Grid container spacing={2} component="div">
        <Grid size={6} component="div">
          <TextField
            fullWidth
            label="نام شرکت"
            variant="filled"
            onChange={handleChange("company_name")}
            InputLabelProps={{ style: { color: "#ccc" } }}
            InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
          />
        </Grid>
        <Grid size={6} component="div">
          <TextField
            fullWidth
            label="سمت شغلی"
            variant="filled"
            InputLabelProps={{ style: { color: "#ccc" } }}
            InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            onChange={handleChange("company_title")}
          />
        </Grid>
        <Grid size={6} component="div">
          <TextField
            fullWidth
            label="کد پستی شرکت"
            variant="filled"
            InputLabelProps={{ style: { color: "#ccc" } }}
            InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            onChange={handleChange("postal_code")}
          />
        </Grid>
        <Grid size={6} component="div">
          <TextField
            fullWidth
            label="شناسه ملی شرکت"
            variant="filled"
            InputLabelProps={{ style: { color: "#ccc" } }}
            InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            onChange={handleChange("company_nid")}
          />
        </Grid>
        <Grid size={12} component="div">
          <TextField
            fullWidth
            label="آدرس محل کار"
            variant="filled"
            InputLabelProps={{ style: { color: "#ccc" } }}
            InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            onChange={handleChange("company_address")}
          />
        </Grid>
        <Grid size={12} component="div" sx={{width: "100%",display: "flex",justifyContent: "center",alignItems: "center",}}>
          <UploadDocuments label="بارگذاری عکس فیش حقوقی" defaultImage={"./Legal-advice.png"} onUpload={(file: any) => setUploadImageJob(file)}/>
        </Grid>
      </Grid>
    </BoxKit>
  );
}
